const REFERENCE_MARKER_DELTA_INDICATOR = Object.freeze("---");

const MarkerInfoKey = Object.freeze({
  MARKER_NAME: "markername",
  MAX_TEMPERATURE: "maxtemperature",
  DELTA: "delta",
  REFERENCE: "reference",
});

const ReferenceSearchType = Object.freeze({
  NONE: 0,
  REFERENCE_ID: 1,
  REFERENCE_NAME: 2,
});

module.exports = {
  REFERENCE_MARKER_DELTA_INDICATOR,
  MarkerInfoKey,
  ReferenceSearchType,
};
